import { Typography } from '@material-ui/core';
import React, { FC } from 'react';

interface HeaderProps {
  className?: string;
  title?: string;
}
const PageTitle: FC<HeaderProps> = ({className, title, ...rest}) => {
  return (
    <>
      <Typography
        variant="h3"
        color="textPrimary"
        style={{ paddingTop: 10 }}
      >
        {title}
      </Typography>
    </>
  );
};

export default PageTitle;
